var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"contact-detail"},[_c('a',{attrs:{"target":"_blank","href":_vm.link}},[(_vm.icon)?_c('Icon',[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_c('p',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.link))]})],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }